import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'styled-theming';
import { Box } from 'rebass/styled-components';

const borderColor = theme.variants('mode', 'variant', {
  default: {
    light: (props) => (props.isEditing ? props.theme.colors.superLightGrey : 'transparent'),
    dark: 'transparent',
  },
  error: {
    light: (props) => props.theme.colors.deepOrange,
    dark: (props) => props.theme.colors.orange,
  },
});

const Container = styled(Box)`
  border-radius: ${(props) => props.theme.radius.small};
  border: 1px solid ${borderColor}};
`;

function ErrorContainer(props) {
  const {
    isEditing, isErrored, ...otherProps
  } = props;

  return (
    <Container
      isEditing={isEditing}
      variant={isErrored ? 'error' : 'default'}
      data-testid="editor-error-container"
      {...otherProps}
    />
  );
}

ErrorContainer.defaultProps = {
  isErrored: false,
};

ErrorContainer.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  isErrored: PropTypes.bool,
};

export default ErrorContainer;
